import { useQuery } from '@tanstack/react-query';
import { slotsApi } from '../services/api';

export function useSlots() {
  return useQuery({
    queryKey: ['slots'],
    queryFn: () => slotsApi.getSlots(),
    staleTime: Infinity, // Slots don't change
  });
}
